import { render, staticRenderFns } from "./AdminSystemSettings.vue?vue&type=template&id=b018fa12"
import script from "./AdminSystemSettings.vue?vue&type=script&lang=js"
export * from "./AdminSystemSettings.vue?vue&type=script&lang=js"
import style0 from "./AdminSystemSettings.vue?vue&type=style&index=0&id=b018fa12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports